
const params01 = {
  "particles": {
    //シェイプの設定
    "number": {
      "value": 60, //シェイプの数
      "density": {
        "enable": true, //シェイプの密集度の設定許可
        "value_area": 1000 //シェイプの密集度
      }
    },
    "shape": {
      "type": "image", //circle、edge、triangle、polygon、star、image から選べる
      "image": {
        "src": "/cdn/shop/files/lp-xmas24-img_snow.png", //雪の画像を設定する ※相対パスでも可
      }
    },
    "opacity": {
      "value": 1.0, //透明度
      "random": true, //透明度ランダムの許可
      "anim": {
        "enable": false, //透明度のアニメーションさせるかどうか
        "speed": 1, //アニメーションのスピード
        "opacity_min": 0.1, //透明度の最小値
        "sync": false //シェイプを同時にアニメーションさせるかどうか
      }
    },
    "size": {
      "value": 10, //シェイプの大きさ
      "random": true, //大きさランダムの許可
      "anim": {
        "enable": false, //大きさアニメーションさせるかどうか
        "speed": 15, //スピード
        "size_min": 5, //スピードの最小値
        "sync": false //同時にアニメーションさせるかどうか
      }
    },
    // 線の設定
    "line_linked": {
      "enable": false, //線を表示するかどうか
    },
    // 動きの設定
    "move": {
      "enable": true, //シェイプの動かすかどうか
      "speed": 0.5, //スピード
      "direction": "bottom", //シェイプの動く方向(none、top、top-right、right、bottom-right、bottom、bottom-left、left、top-left から選べる)
      "random": false, // 動きはランダム
      "straight": false, // 動きをとどめない
      "out_mode": "out", //エリア外に出たシェイプの動き(out、bounce から選べる)
      "bounce": false, //跳ね返りなし
      "attract": {
        "enable": true,
        "rotateX": 300,
        "rotateY": 1200
      }
    }
  },
  "interactivity": {
    "detect_on": "canvas",
    "events": {
      //マウスオーバー時
      "onhover": {
        "enable": false, //マウスオーバーの許可
      },
      //クリック時
      "onclick": {
        "enable": false, //クッリクの許可
      },
      "resize": true
    }
  },
  "retina_detect": true
}

const params02 = {
  "particles": {
    //シェイプの設定
    "number": {
      "value": 7, //シェイプの数
      "density": {
        "enable": true, //シェイプの密集度の設定許可
        "value_area": 1000 //シェイプの密集度
      }
    },
    "shape": {
      "type": "image", //circle、edge、triangle、polygon、star、image から選べる
      "image": {
        "src": "/cdn/shop/files/lp-xmas24-img_snow02.png", //雪の画像を設定する ※相対パスでも可
      }
    },
    "opacity": {
      "value": 1.0, //透明度
      "random": true, //透明度ランダムの許可
      "anim": {
        "enable": false, //透明度のアニメーションさせるかどうか
        "speed": 1, //アニメーションのスピード
        "opacity_min": 0, //透明度の最小値
        "sync": false //シェイプを同時にアニメーションさせるかどうか
      }
    },
    "size": {
      "value": 20, //シェイプの大きさ
      "random": true, //大きさランダムの許可
      "anim": {
        "enable": false, //大きさアニメーションさせるかどうか
        "speed": 15, //スピード
        "size_min": 15, //スピードの最小値
        "sync": true //同時にアニメーションさせるかどうか
      }
    },
    // 線の設定
    "line_linked": {
      "enable": false, //線を表示するかどうか
    },
    // 動きの設定
    "move": {
      "enable": true, //シェイプの動かすかどうか
      "speed": 0.5, //スピード
      "direction": "bottom", //シェイプの動く方向(none、top、top-right、right、bottom-right、bottom、bottom-left、left、top-left から選べる)
      "random": false, // 動きはランダム
      "straight": false, // 動きをとどめない
      "out_mode": "out", //エリア外に出たシェイプの動き(out、bounce から選べる)
      "bounce": false, //跳ね返りなし
      "attract": {
        "enable": true,
        "rotateX": 300,
        "rotateY": 1200
      }
    }
  },
  "interactivity": {
    "detect_on": "canvas",
    "events": {
      //マウスオーバー時
      "onhover": {
        "enable": false, //マウスオーバーの許可
      },
      //クリック時
      "onclick": {
        "enable": false, //クッリクの許可
      },
      "resize": true
    }
  },
  "retina_detect": true
}

particlesJS("snow_particlesjs", params01);
particlesJS("snow_particlesjs02", params02);
